// tl -carrier router

import Layout from "@/layout";

export default {
  path: "/market-insights",
  component: Layout,
  redirect: "/market-insights/rate-check",
  meta: {
    title: "Market Insights",
    icon: "market-insights",
  },
  children: [
    {
      path: "rate-check",
      name: "marketInsights",
      component: () => import("@/views/carrier-common/index.vue"),
      meta: {
        title: "Rate Check",
        system: "carrier",
      },
    },
    {
      path: "load-profit-calculator",
      name: "marketInsights",
      component: () => import("@/views/carrier-common/index.vue"),
      meta: {
        title: "Load Profit Calculator",
        system: "carrier",
      },
      // hidden: true,
    },
    {
      path: "fuel-surcharge-calculator",
      name: "marketInsights",
      component: () => import("@/views/carrier-common/index.vue"),
      meta: {
        title: "Fuel Surcharge Calculator",
        system: "carrier",
      },
      // hidden: true,
    },
    {
      path: "capacity-indicator",
      name: "marketInsights",
      component: () => import("@/views/carrier-common/index.vue"),
      meta: {
        title: "Capacity Indicator",
        system: "carrier",
      },
      // hidden: true,
    },
  ],
};
